import store from './store/index'
import router from './router'
export default {
    store,
    router
}